'use client';
import { useGetBasketQuery } from '@akinon/next/data/client/basket';
import { Icon, Link } from '@theme/components';
import { ROUTES } from '@theme/routes';
import clsx from 'clsx';

export default function MiniBasketButton() {
  const { data, isLoading } = useGetBasketQuery();

  return (
    <Link
      href={ROUTES.BASKET}
      aria-label="Sepete Git"
      className={clsx([
        'size-8',
        'flex items-center justify-center',
        'px-0',
        'border-none',
        'h-auto',
        'text-black-100',
        'hover:bg-transparent',
        'hover:text-black-100',
        'relative'
      ])}
    >
      {!isLoading && data?.basketitem_set?.length > 0 && (
        <span className="absolute -top-1 -right-1 text-xs text-primary-black bg-white border rounded-full p-[6px] aspect-square flex items-center justify-center leading-[0px] font-semibold">
          {data.basketitem_set.length}
        </span>
      )}

      <Icon name="basket" size={32} className="fill-white" />
    </Link>
  );
}
